import { useEffect } from 'react';
import { injectIntl } from 'react-intl';
import { Modal } from 'antd';
import { mediaHook } from 'customHooks';

import { KAEML_CALENDER_BOOK_MEETING_LINK } from 'constants/pixels';

import { ReactComponent as CloseIcon } from 'assets/bosta-icons/Close.svg';

const CalendlyModal = ({
  intl,
  close,
  modalAction = () => {},
  title = '',
  content,
  cancelAction = false,
  mobileScreenSizes: { isSmallMobileScreen },
  ...props
}) => {
  const onCancel = () => {
    if (cancelAction) {
      cancelAction();
    }
    close();
  };

  useEffect(() => {
    const head = document.querySelector('head');
    const script = document.createElement('script');
    script.setAttribute(
      'src',
      'https://assets.calendly.com/assets/external/widget.js'
    );
    head.appendChild(script);
  }, []);

  return (
    <Modal
      title={
        <CloseIcon onClick={onCancel} className="calendly-modal__close-icon" />
      }
      onCancel={onCancel}
      width={'50%'}
      wrapClassName="br-confirmation-modal "
      footer={null}
      maskClosable={false}
      {...props}
    >
      <div>
        <div id="schedule_form">
          <div
            className="calendly-inline-widget"
            data-url={KAEML_CALENDER_BOOK_MEETING_LINK}
            style={{
              minWidth: '320px',
              height: !isSmallMobileScreen ? '550px' : '500px',
              width: '100%'
            }}
          />
        </div>
      </div>
    </Modal>
  );
};

export default injectIntl(mediaHook(CalendlyModal));
